var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgUser = function SvgUser(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.743 16.132c-.185-.555-.52-1.115-1.014-1.44-1.202-.799-2.672-.937-3.887-1.66-.374-.222-.318-.669-.339-1.032C14.28 10.937 15 9.423 15 8c0-2.22-1.454-3-3-3s-3 .78-3 3c0 1.474.673 2.95 1.497 4-.033.363.04.797-.34 1.023-1.21.72-2.686.834-3.886 1.63-.494.326-.829.924-1.014 1.48-.19.575-.268 1.289-.256 1.867H19c.012-.578-.066-1.292-.256-1.868Z"
  })));
};
export { SvgUser as ReactComponent };
export default __webpack_public_path__ + "static/media/user.4cacb4c02841bbcb128f9d5a04136b25.svg";